import { atom } from 'recoil';

export const financialSummuryOrdenationState = atom<{
  selectedOrderType: string | null;
  selectedDisplayOrder: string | null;
  hasOrdernation: boolean | null;
}>({
  key: 'financialSummuryOrdenationState',
  default: {
    selectedOrderType: null,
    selectedDisplayOrder: null,
    hasOrdernation: false,
  },
});
